<template>
  <div>
    <ckeditor :editor="editor" @input="$emit('input', $event)" :value="value" :config="editorConfig"></ckeditor>
  </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
// import BoldPlugin from '@ckeditor'

export default {
  name: "editorText",
  props: {
    value: null,
  },
  components: {
    // Use the <ckeditor> component in this view.
    ckeditor: CKEditor.component
  },
  data: () => ({
    editor: ClassicEditor,
    editorConfig: {
      toolbar: {
        items: [
          'heading', 'bold', 'italic', '|', 'undo', 'redo', '-', 'numberedList'
        ]
      },
    }
  }),
  mounted() {
  }
}
</script>

<style scoped>

</style>